module.exports = __webpack_public_path__ + "img/cashmere-signup-banner.292d595f.png";